<template>
  <div>
    <h1 class="common__main-title"> Mail Template {{ routeStateName }} Confirm</h1>
    <div class="common__sub-title">
      <span>{{ routeStateName }}</span>
    </div>
    <div class="content-wrapper">
      <DetailForm :template="mailTemplate"/>
      <div class="d-flex justify-content-between">
        <b-button pill variant="secondary"
          :to="{
            name: (prevRoute && prevRoute.name) || 'MailTemplateAdd',
            params: {
              mailTemplateId: $route.params.mailTemplateId || null,
              editingMailTemplate: $route.params.editingMailTemplate,
            }
          }"
        >
          Back
        </b-button>
        <b-button pill variant="primary" @click="register">
          {{ routeStateName }}
        </b-button>
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import DetailForm from '@/components/parts/mails/templates/DetailForm.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import { Route } from 'vue-router'
import { MailTemplate } from '@/store/mails/templates/types'

export default Vue.extend({
  components: {
    DetailForm,
    Loading,
  },

  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      vm.prevRoute = from // eslint-disable-line no-param-reassign
    })
  },

  data(): {
    mailTemplate: MailTemplate,
    prevRoute: Route|null,
    isLoading: boolean,
    } {
    return {
      mailTemplate: JSON.parse(this.$route.params.editingMailTemplate),
      prevRoute: null,
      isLoading: false,
    }
  },

  computed: {
    routeStateName(): string|Error {
      switch (this.$route.name) {
        case 'MailTemplateConfirm':
          return 'Register'
        case 'MailTemplateEditConfirm':
          return 'Edit'
        case 'MailTemplateCopyConfirm':
          return 'Copy'
        default:
          throw Error(`未知のルート名: ${this.$route.name}`)
      }
    },
  },

  methods: {
    async register() {
      this.isLoading = true
      const template: MailTemplate = this.mailTemplate

      try {
        if (this.$route.name === 'MailTemplateEditConfirm') {
          // 編集時
          await this.$store.dispatch('editMailTemplate', {
            mailTemplateId: this.$route.params.mailTemplateId,
            template,
          })
        } else {
          // 新規登録・コピー時
          await this.$store.dispatch('registerMailTemplate', template)
        }
        this.isLoading = false
        await this.$bvModal.msgBoxOk('Success !')
        this.$router.push({
          name: 'MailTemplates',
        })
      } catch (error: any) {
        this.isLoading = false
        let message: string = error
        if (_.has(error, 'response')) {
          const { response } = error
          message = response.data.message
        }
        await this.$bvModal.msgBoxOk(`Error: ${message}`)
        this.$router.push({
          name: this.prevRoute?.name || 'MailTemplateAdd',
          params: { editingMailTemplate: this.$route.params.editingMailTemplate },
        })
      }
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}

.main-content {
  background: #fff;
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
}
</style>
